import debug from 'utils/debug';

const D2 = debug('utils:sgerp-api');

/**
 * This function is to get all selected endpoint by calling
 * the API based on the number of pages it has in order to get all the data
 *
 * * Note: Not the best way to do it, might need to relook at this in the future
 * * Current implementation calls API multiple times based on number of pages with a maximum limit of 1000.
 * * This will slow down process when there are a lot of data stored in selected simulation
 *
 * Implementation:
 *  1. Fetch first page > get total count
 *  2. Get number of pages, and get an array of numbers
 *  3. Fetch all data from sgerp, and store into state
 */
export const fetchAll = async (url, api, prevObjects) => {
  const response = await api.fetch(url);

  const data = await response.json();
  // // eslint-disable-next-line no-console
  // console.log('*** GET', url, data);

  if (!response.ok) {
    const errorObj = {
      status: response.status.toString(),
      statusText: response.statusText.toString(),
      ...data,
    };
    throw new Error(JSON.stringify(errorObj));
  }
  const objects = data?.objects || [];
  const allObjects = prevObjects ? [...prevObjects, ...objects] : objects;

  const nextUrl = data?.meta?.next_offset;

  if (!nextUrl) {
    return allObjects;
  }

  return await fetchAll(nextUrl, api, allObjects);
};

const fetchCollection2 = async (api, collection, filter = {}, opts = {}) =>
  D2.A.FUNCTION(
    'fetchCollection2',
    { api, collection, filter, opts },
    async ({ $D2 }) => {
      const { address, prefix } = api;

      const query = {
        model: collection,
        ...filter,
      };

      const queryString = Object.entries(query)
        .reduce((memo, [k, v]) => {
          return [...memo, [k, encodeURIComponent(v)].join('=')];
        }, [])
        .join('&');

      const objectAddress = [
        [address, prefix].join(''),
        'microservices/get',
      ].join('/');

      const fetchUrl =
        queryString !== ''
          ? [objectAddress, queryString].join('?')
          : objectAddress;

      const objects = await fetchAll(fetchUrl, api);

      const result = {
        meta: {},
        objects,
      };

      return result;
    }
  );

export default fetchCollection2;
